// Async Thunk for SignIn
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CognitoService from "../service/cognito";
import { resetPasswordAttrs } from "../interfaces/interface";



export const resetPasswordAction = createAsyncThunk(
  "auth/resetPassword",

  async (resetPasswordAttrs: resetPasswordAttrs) => {
    const {email, newPassword, confirmationCode} = resetPasswordAttrs;
    const response = await CognitoService.resetPassword(email, confirmationCode, newPassword);
    return JSON.parse(JSON.stringify(response));
  },
);

export const getConfirmationCodeAction = createAsyncThunk(
  "auth/getConfirmationCode",

  async (email: string) => {
    const response = await CognitoService.forgotPassword(email);
    return JSON.parse(JSON.stringify(response));
  },
);
